import React, { forwardRef, useEffect, useImperativeHandle, useState } from "react";
import { getSpecifiedCommercial } from "../../server/axios";

// eslint-disable-next-line no-undef
export const SpecifiedCommercialModal = forwardRef((props, ref) => {
    const [modalShowing, setModalShowing] = useState(false)
    const [modalActive, setModalActive] = useState(false)
    const [specifiedCommercial, setSpecifiedCommercial] = useState({
        sctlPhamacyName: "",
        sctlRepresentative: "",
        sctlLocation: "",
        sctlPhone: "",
        sctlMailAddress: "",
        sctlPaymentMethod: "",
        sctlDeliveryTime: "",
        sctlReturnsExchanges: "",
    });
    useEffect(() => {
        if (props.tenantId) {
            getSpecifiedCommercial({tenantId: props.tenantId}).then(res => {
                setSpecifiedCommercial({
                    sctlPhamacyName: res.data.target.sctlPhamacyName,
                    sctlRepresentative: res.data.target.sctlRepresentative,
                    sctlLocation: res.data.target.sctlLocation,
                    sctlPhone: res.data.target.sctlPhone,
                    sctlMailAddress: res.data.target.sctlMailAddress,
                    sctlPaymentMethod: res.data.target.sctlPaymentMethod,
                    sctlDeliveryTime: res.data.target.sctlDeliveryTime,
                    sctlReturnsExchanges: res.data.target.sctlReturnsExchanges,
                });
            })
        }
    }, [props.tenantId])

    useEffect(() => {
        if (modalShowing) {
            setModalActive(true)
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
    }, [modalShowing])

    const closeModal = () => {
        setModalActive(false)
        setTimeout(() => {
            setModalShowing(false)
        }, 600)
    }
    const showModal = () => {
        setModalShowing(true)
    }
    useImperativeHandle(ref, () => ({
        showModal,
    }))

    return (
        <div className="relative">
            {modalShowing && (
                <div
                    className={`tw-fixed tw-z-40 tw-top-0 tw-left-0 tw-w-screen tw-h-screen tw-bg-black/40 tw-transition-opacity tw-duration-500 tw-px-4 tw-flex tw-justify-center tw-items-center ${modalActive ? 'tw-opacity-100' : 'tw-opacity-0'}`}
                    onClick={() => {
                        closeModal()
                    }}>
                    <div
                        className={`tw-py-4 tw-max-h-screen tw-overflow-scroll tw-transition-all tw-duration-500 tw-pb-32 ${modalActive ? 'tw-opacity-100 tw-scale-100' : 'tw-opacity-0 tw-scale-105'}`}>
                        <div className="tw-p-4 tw-bg-white tw-rounded tw-border tw-border-slate-300 tw-shadow-lg tw-w-[calc(100vw-2rem)] md:tw-w-[600px]" onClick={e => {
                            e.stopPropagation()
                        }}>
                            <div className="tw-flex tw-justify-between">
                                <h3 className="tw-text-xl">特定商取引法に基づく表記</h3>
                                <button onClick={()=>closeModal()} className="-tw-mr-2 -tw-mt-2 tw-flex tw-justify-center tw-items-center tw-w-10 tw-h-10 tw-rounded-full hover:tw-bg-black/10 tw-transition-colors">
                                    <svg className="tw-w-8 tw-h-8 tw-text-slate-600" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>close</title><path fill="currentColor" d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z" /></svg>
                                </button>
                            </div>
                            <ul className="tw-mt-4 tw-space-y-4">
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">薬局名</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlPhamacyName}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">代表者</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlRepresentative}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">所在地</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlLocation}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">電話番号</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlPhone}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">E-MAIL</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlMailAddress}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">支払い方法</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlPaymentMethod}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">商品引き渡し時期</h6>
                                    <p className="tw-text-sm">{specifiedCommercial.sctlDeliveryTime}</p>
                                </li>
                                <li>
                                    <h6 className="tw-text-slate-500 tw-font-bold tw-text-xs">返品・交換について</h6>
                                    <p className="tw-text-sm tw-leading-6">{specifiedCommercial.sctlReturnsExchanges}</p>
                                </li>
                                <li className="tw-flex tw-justify-center">
                                    <button onClick={()=>closeModal()} className="tw-text-sm tw-font-bold tw-py-2 tw-px-4 tw-rounded hover:tw-bg-black/10 tw-transition-colors">閉じる</button>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            )}
        </div>
    )
})